/**
 * @doc directive
 * @id GraphComment:comment
 *
 * @description directive for comment
 */
angular.module('GraphCommentModule').controller('Bbf3dController', [
  '$scope',
  '$element',
  '$timeout',
  '$translate',
  '$rootScope',
  'CommentService',
  'Utils',
function (
  $scope, $element, $timeout, $translate, $rootScope, CommentService, Utils
) {
  'use strict';

  if (!$rootScope.bbf3dCount) $rootScope.bbf3dCount = 0;

  if ( $rootScope.website.theme === 'auto') {
    $scope.mainThemeClass = 'gc-theme-' + (Utils.getParameterByName('theme') || 'light');
  } else {
    $scope.mainThemeClass = 'gc-theme-' + $rootScope.website.theme;
  }

  console.log('Utils.getParameterByName(theme)', $scope.mainThemeClass )
  $scope.openBbf3d = function() {
    $scope.showBbf3dOverlay = $rootScope.bbf3dCount === 0; // only show the overlay on the top-level
    $scope.bbf3dLimit = 20;
    $scope.bbf3dLevel = $rootScope.bbf3dCount;

    document.body.classList.add('no-scroll');

    var $comment = document.querySelector('#comment-' + $scope.comment._id);
    var top = Math.max(0, $comment.getBoundingClientRect().top - 100);

    if ($rootScope.bbf3dCount === 0 && Utils.inIframe()) {
      $scope.bbf3dTop = top + parseInt($rootScope.fixedHeaderHeight) + 40 + 'px';
    } else {
      $scope.bbf3dTop = '10px';
    }

    if ($rootScope.bbf3dCount === 0) {
      var scroll = Utils.getScrollPosition();
      $scope.bbf3dScrollTop = scroll.top;
    } else {
      $scope.bbf3dScrollTop = 0;
    }

    $rootScope.bbf3dCount += 1;

    CommentService.getThread({
      bbf3d: true,
      parent_id: $scope.comment._id,
      offset: 20,
      limit: 10000,
    }).success(function(thread) {
      $scope.comment.child_comments = CommentService._comments[$scope.comment._id].child_comments;
    });

    $timeout(function() {
      $scope.bbf3dInitialScroll = Utils.inIframe()
        ? top
        : document.querySelector('.gc-all-answers.has-overlay').scrollTop
      ;
    });

    // mark comment as read
    $timeout(function() {
      var $newComments = $element[0].querySelectorAll('.gc-all-answers-comment .gc-is-new');
      if ($newComments.length) {
        $scope.bbf3dObserver = new IntersectionObserver(function(entries) {
          var intersecting = entries.filter(entry => entry.isIntersecting);
          intersecting.forEach(function(entry) {
            var target = entries[0].target;
            if (target) {
              $scope.bbf3dObserver.unobserve(target);
              var commentId = target.id.replace('comment-', '');
              var comment = CommentService.retrieveComment(commentId);
              ReadStatusService.markAsRead(comment);
              comment.is_new = false;
              checkParentsHasNoMorNewComments(comment);
            }
          });
        }, { threshold: 1 });

        $newComments.forEach(el => $scope.bbf3dObserver.observe(el));
      }
    });
  };

  $scope.closeBbf3d = function(scrollToTop) {
    $rootScope.bbf3dCount = $scope.bbf3dLevel;

    if ($rootScope.bbf3dCount === 0) {
      document.body.classList.remove('no-scroll');
      $rootScope.bbf3dVisible = false;
    }

    $rootScope.$emit('bbf3d-close', $scope.bbf3dLevel);

    if ($scope.bbf3dObserver) $scope.bbf3dObserver.disconnect();

    if (scrollToTop) {
      if (Utils.inIframe()) {
        $rootScope.$emit('scrollTo', $scope.bbf3dInitialScroll, null, 0);
      } else {
        document.querySelector('.gc-all-answers.has-overlay').scrollTo(0, $scope.bbf3dInitialScroll);
      }
    }
  };

  $scope.bbf3dShowMore = function() {
    $scope.bbf3dLimit += 20;
  };

  $scope.addComment = function (data) {
    return CommentService.addMessage(data);
  };

  $scope.editComment = function (data) {
    return CommentService.updateMessage(data);
  };

}])
.directive('bbf3d', function () {
  'use strict';
  return {
    replace: true,
    restrict: 'E',
    scope: {
      comment: '=',
    },
    templateUrl: 'bbf3d.html',
    controller: 'Bbf3dController',
    link: function (scope, el/*, attr*/) {

      scope.$watch('comment', function() {
        scope.openBbf3d();
      });
    }
  };
});
